class BlockProductMediaGallery extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this._waitForSlickInit(() => this._initHandlers())
  }

  _waitForSlickInit(callback) {
    const mainSliderEl = this.querySelector('.main-img-slider')
    if (mainSliderEl && mainSliderEl.classList.contains('slick-initialized')) {
      callback()
    } else {
      setTimeout(() => this._waitForSlickInit(callback), 100)
    }
  }

  _initHandlers() {
    const ACTIVE_CLASSNAME = 'border-[var(--color-primary-500)]'
    const INACTIVE_CLASSNAME = 'border-transparent'

    const mainSliderEl = this.querySelector('.main-img-slider')
    const thumbnails = Array.from(this.querySelectorAll('#thumbnails-gallery-alternative .thumbnail'))
    let currentThumbnail

    const hotspotClasses = [
      'h-[239px]', 'lg:h-[317px]', 'xl:h-[486px]' , 'xl:max-h-[486px]','2xl:h-[562px]','2xl:max-h-[562px]'
    ]

    function resetHotspots() {
      document.querySelectorAll('.layer-tooltip-hotspot-thumbnail').forEach((el) => {
        el.classList.add('opacity-0')
      })
      document.querySelectorAll('.layer-tooltip-hotspot-content').forEach((el) => {
        el.classList.add('opacity-0', 'h-0')
        el.parentElement?.parentElement?.classList.remove('h-auto')
        el.parentElement?.parentElement?.classList.add(...hotspotClasses)
      })
    }

    function updateActiveThumbnail(index) {
      const thumbnail = thumbnails[index]
      if (!thumbnail) return

      if (currentThumbnail) {
        currentThumbnail.classList.remove(ACTIVE_CLASSNAME)
        currentThumbnail.classList.add(INACTIVE_CLASSNAME)
      }

      thumbnail.classList.add(ACTIVE_CLASSNAME)
      thumbnail.classList.remove(INACTIVE_CLASSNAME)
      currentThumbnail = thumbnail

      thumbnail.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' })
    }

    updateActiveThumbnail(0)

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        $(mainSliderEl).slick('slickGoTo', index)
      })
    })

    $(mainSliderEl).on('afterChange', function (_event, _slick, currentSlide) {
      updateActiveThumbnail(currentSlide)
      resetHotspots()
    })

    document.querySelectorAll('.layer-tooltip-hotspot').forEach((n) => {
      n.addEventListener('click', () => {
        resetHotspots()

        const spotId = n.id
        n.querySelector(`#${spotId}-thumbnail`)?.classList.remove('opacity-0')

        const contentElement = document.querySelector(`#${spotId}-content`)
        if (!contentElement) return

        contentElement.classList.remove('h-0', 'opacity-0')
        contentElement.parentElement?.parentElement?.classList.add('h-auto')
        contentElement.parentElement?.parentElement?.classList.remove(...hotspotClasses)

        $('#detail .main-img-slider').slick('setPosition')
      })
    })
  }
}

customElements.define('block-product-media-gallery', BlockProductMediaGallery)
